module.exports = __webpack_public_path__ + "img/device.a4f47e20.svg";